import BannerCard from "../Component/BannerCard";
import Services from "../Component/Services";
import ServicesCard from "../Component/ServicesCard";
import AboutCard from "../Component/AboutCard";
import IconCard from "../Component/IconCard";
import ReviewCard from "../Component/ReviewCard";
import AboutShape from "../images/AboutShape.svg";
import CounterCard from "../Component/CounterCard"
const Home = () => {
    return (
        <>
        <section id="Banner" className='py-20'>
        <BannerCard/>
        </section>
                <section id="AboutCard" className="my-20">
          <AboutCard/>
        </section>
        <section id="servicesCard" className="mt-20">
          <ServicesCard/>
        </section>
        <section id="IconCard" className="py-20">
           <IconCard/>
        </section>
        <section id="clientReviews" className="py-20">
          <ReviewCard/>
        </section>
        {/* <section id="counter" className="pt-20">
          <CounterCard/>
        </section> */}
 
        </>
)}
export default Home;